module.exports = __webpack_public_path__ + "img/image-mt-4.f8badbb3.png";